import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type {
  ListAffiliateCommissionsParams,
  ListAffiliateCommissionsResponse,
} from './list-affiliate-commissions.types'

export const listAffiliateCommissions = async (
  params?: ListAffiliateCommissionsParams,
): Promise<ListAffiliateCommissionsResponse> => {
  const response = await apiClient.get<ListAffiliateCommissionsResponse>(
    '/v1/affiliation/commissions',
    {
      params: {
        PageNumber: params?.pageNumber ?? 1,
        PageSize: params?.pageSize ?? 10,
      },
    },
  )
  return response.data
}

export const useListAffiliateCommissions = (
  params?: ListAffiliateCommissionsParams,
) => {
  return useQuery({
    queryKey: ['affiliate-commissions', params],
    queryFn: () => listAffiliateCommissions(params),
  })
}
